export default __webpack_public_path__ + "static/media/screen-view.32ed6f61.svg";